<script lang="ts">
    import { twMerge } from "tailwind-merge"
    let classList = ""
    export { classList as class }
    export let disabled = false
    $: disableClassList = disabled ? "grayscale" : ""
</script>

<div
    on:click
    on:keydown
    class={twMerge(
        "flex w-full align-top rounded-2xl p-3 flex-col bg-white dark:bg-neutral-800 relative font-sans",
        disableClassList,
        classList,
    )}
    {...$$restProps}
    on:focus
    on:blur
>
    <slot />
</div>
